<template>
  <v-card class="card-container">
    <v-dialog v-model="importDialog" max-width="440" persistent>
      <v-card flat class="pa-6 text-center">
        <v-icon size="48" color="success" class="mb-3"
          >mdi-check-circle-outline</v-icon
        >

        <div v-if="addResponse.message">
          <strong>Importação concluída!</strong>
          <p class="mt-3">{{ addResponse.message }}</p>
        </div>
        <div v-else>
          <strong>Fornecedores importados com sucesso!</strong>
          <p class="mt-3">
            Os fornecedores foram importados e já estão disponíveis!
          </p>
        </div>

        <div
          v-if="
            addResponse.notRegisteredSuppliers &&
            addResponse.notRegisteredSuppliers.length > 0
          "
          class="text-left mb-3"
        >
          <v-alert type="warning" dense outlined class="mt-2">
            <strong>{{ addResponse.notRegisteredSuppliers.length }}</strong>
            fornecedor(es) não foram importados pois já existem no sistema.
          </v-alert>
        </div>

        <div class="d-flex justify-center align-center mt-2">
          <v-btn
            class="primary-button ma-0"
            depressed
            @click="
              ;(resendKey = !resendKey),
                (suppliers = []),
                (importDialog = false),
                (importSummary = ''),
                (file = null)
            "
          >
            Ok
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <div class="back pt-3">
      <div class="main-toolbar mb-2">
        <div class="icon-back">
          <v-icon color="white" size="27">mdi-store-plus-outline</v-icon>
        </div>

        <span class="main-toolbar-title">Importar Fornecedores</span>

        <v-spacer></v-spacer>

        <div class="d-flex align-center toolbar-actions">
          <v-btn
            class="primary-button mr-2 hidden-sm-and-down"
            depressed
            :loading="downloadLoading"
            @click="downloadModel"
          >
            {{ $t('Baixar planilha modelo') }}
          </v-btn>

          <v-btn
            class="secondary-button mr-2"
            depressed
            :disabled="file == null"
            :loading="tableLoading"
            @click="onFileChange"
          >
            {{ $t('Importar Arquivo') }}
          </v-btn>

          <v-btn
            class="terciary-button mr-2"
            depressed
            dark
            :disabled="suppliers.length == 0"
            :loading="addLoading"
            @click="addSuppliers"
          >
            Cadastrar fornecedores
          </v-btn>

          <v-btn
            v-if="suppliers.length == 0"
            class="quaternary-button"
            depressed
            color="#FF4F64"
            @click="cancel"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-btn
            v-else
            class="quaternary-button"
            depressed
            color="#FF4F64"
            @click="resend"
          >
            Refazer envio
          </v-btn>
        </div>
      </div>

      <v-row class="ma-0" dense align="center">
        <v-col cols="12">
          Aqui você pode importar uma planilha de fornecedores para dentro do
          sistema com base na planilha modelo que fornecemos.
          <br />
          A cada importação, confirme se está com a planilha modelo atualizada
          para garantir o funcionamento correto.
        </v-col>
        <v-col v-if="importSummary" cols="12" class="pt-2 pb-0">
          <v-alert type="info" dense outlined>{{ importSummary }}</v-alert>
        </v-col>
        <v-col v-if="suppliers && suppliers.length == 0">
          <label class="label">{{ $t('Arquivo') }}</label>
          <div class="d-flex justify-center">
            <v-file-input
              v-model="file"
              show-size
              accept=".xls, .xlsx"
              outlined
              dense
              prepend-icon=""
              prepend-inner-icon="mdi-paperclip"
              class="primary-input"
              hide-details="auto"
            >
            </v-file-input>
          </div>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div id="suppliers">
          <v-form ref="form">
            <v-card
              class="ma-2 py-2"
              v-for="(supplier, i) in suppliers"
              :key="i"
              flat
              outlined
            >
              <div class="supplier-row-header px-3 py-1">
                <strong>{{ i + 1 }}</strong>
              </div>
              <div class="supplier-scroll-wrapper">
                <div class="supplier-fields-row">
                  <div class="supplier-field supplier-field--sm">
                    <span class="text ml-1">Tipo de pessoa</span>
                    <v-select
                      v-model="supplier.personType"
                      :items="personTypes"
                      item-text="text"
                      item-value="value"
                      hide-details="auto"
                      class="primary-input"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Nome</span>
                    <v-text-field
                      v-model="supplier.name"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Nome"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                    />
                  </div>

                  <div class="supplier-field" v-if="supplier.personType !== 1">
                    <span class="text ml-1">Nome Corporativo</span>
                    <v-text-field
                      v-model="supplier.corporateName"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Nome corporativo"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">WebSite</span>
                    <v-text-field
                      v-model="supplier.webSite"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="https://..."
                      outlined
                      dense
                    />
                  </div>

                  <div
                    class="supplier-field supplier-field--sm"
                    v-if="supplier.personType !== 1"
                  >
                    <span class="text ml-1">CNPJ</span>
                    <v-text-field
                      v-model="supplier.cnpj"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="00.000.000/0000-00"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                    />
                  </div>

                  <div
                    class="supplier-field supplier-field--sm"
                    v-if="supplier.personType === 1"
                  >
                    <span class="text ml-1">CPF</span>
                    <v-text-field
                      v-model="supplier.cpf"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="000.000.000-00"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                    />
                  </div>

                  <div class="supplier-field supplier-field--sm">
                    <span class="text ml-1">CEP</span>
                    <v-text-field
                      v-model="supplier.cep"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="00000-000"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field supplier-field--lg">
                    <span class="text ml-1">Endereço</span>
                    <v-text-field
                      v-model="supplier.address"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Logradouro"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field supplier-field--xs">
                    <span class="text ml-1">Número</span>
                    <v-text-field
                      v-model="supplier.locationNumber"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Nº"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Complemento</span>
                    <v-text-field
                      v-model="supplier.complement"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Complemento"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Bairro</span>
                    <v-text-field
                      v-model="supplier.district"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Bairro"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Cidade</span>
                    <v-text-field
                      v-model="supplier.city"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Cidade"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field supplier-field--xs">
                    <span class="text ml-1">UF</span>
                    <v-text-field
                      v-model="supplier.state"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="UF"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Contato Corporativo</span>
                    <v-text-field
                      v-model="supplier.businessContact"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Contato"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">E-mail Corporativo</span>
                    <v-text-field
                      v-model="supplier.businessEmail"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="email@..."
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Telefone Corporativo</span>
                    <v-text-field
                      v-model="supplier.businessPhoneNumber"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="(00) 0000-0000"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Celular Corporativo</span>
                    <v-text-field
                      v-model="supplier.businessCellPhoneNumber"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="(00) 00000-0000"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Contato Técnico</span>
                    <v-text-field
                      v-model="supplier.technicalContact"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Contato"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">E-mail Técnico</span>
                    <v-text-field
                      v-model="supplier.technicalEmail"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="email@..."
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Telefone Técnico</span>
                    <v-text-field
                      v-model="supplier.technicalPhoneNumber"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="(00) 0000-0000"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field">
                    <span class="text ml-1">Celular Técnico</span>
                    <v-text-field
                      v-model="supplier.technicalCellPhoneNumber"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="(00) 00000-0000"
                      outlined
                      dense
                    />
                  </div>

                  <div class="supplier-field supplier-field--xl">
                    <span class="text ml-1">Informações Adicionais</span>
                    <v-text-field
                      v-model="supplier.additionalInformation"
                      hide-details="auto"
                      class="primary-input"
                      placeholder="Informações adicionais"
                      outlined
                      dense
                    />
                  </div>
                </div>
              </div>
            </v-card>
          </v-form>
        </div>
      </v-expand-transition>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  name: 'ImportSuppliers',

  data() {
    return {
      loading: false,
      tableLoading: false,
      downloadLoading: false,
      apiService: new ApiService(),
      suppliers: [],
      importDialog: false,
      addResponse: {},
      resendKey: false,
      addLoading: false,
      file: null,
      fileBase64: null,
      institutionId: null,
      importSummary: '',
    }
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
  },

  computed: {
    personTypes() {
      return [
        { text: this.$t('Pessoa jurídica'), value: 0 },
        { text: this.$t('Pessoa física'), value: 1 },
      ]
    },
  },

  methods: {
    resend() {
      this.resendKey = !this.resendKey
      this.suppliers = []
      this.importSummary = ''
      this.fileBase64 = null
    },

    readFile() {
      if (this.file) {
        const reader = new FileReader()
        reader.readAsDataURL(this.file)
        reader.onload = () => {
          this.fileBase64 = reader.result
          const fileModel = {
            File: reader.result,
            InstitutionId: this.institutionId,
          }

          this.tableLoading = true
          this.apiService
            .post('supplier/import/preview', fileModel)
            .then((response) => {
              const content = response.content
              this.suppliers = Array.isArray(content) ? content : []
              this.tableLoading = false
            })
            .catch(() => {
              this.tableLoading = false
            })
        }
      }
    },

    async downloadModel() {
      this.downloadLoading = true
      try {
        const response = await this.apiService.get(
          'supplier/downloadImportTemplate'
        )

        if (response && typeof response === 'string') {
          const byteCharacters = atob(response)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'template_fornecedores.xlsx')
          document.body.appendChild(link)
          link.click()

          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }, 100)
        }
      } catch {
        this.$toast.error('Erro ao baixar a planilha modelo')
      } finally {
        this.downloadLoading = false
      }
    },

    async addSuppliers() {
      if (this.$refs.form.validate()) {
        this.addLoading = true
        const model = {
          suppliers: this.suppliers,
          institutionId: this.institutionId,
        }

        this.apiService
          .post('supplier/import/confirm', model)
          .then((response) => {
            const content = response.content || {}
            this.addResponse = content
            this.importSummary = content.message || ''
            this.importDialog = true
            this.addLoading = false
          })
          .catch(() => {
            this.addLoading = false
          })
      } else {
        this.$toast.error(
          'Verifique os campos dos fornecedores e tente novamente'
        )
      }
    },

    onFileChange() {
      this.readFile()
    },

    cancel() {
      this.file = null
    },
  },
}
</script>

<style scoped>
#suppliers {
  margin-top: 15px;
  max-height: 450px;
  overflow-y: auto;
}

#suppliers::-webkit-scrollbar {
  background-color: #f9f9f9;
  width: 8px;
  border-radius: 6px;
}

#suppliers::-webkit-scrollbar-thumb {
  background-color: #e9e9e9;
  width: 8px;
  border-radius: 6px;
}

.supplier-row-header {
  font-size: 0.85rem;
  color: #555;
  border-bottom: 1px solid #eee;
  margin-bottom: 4px;
}

.supplier-scroll-wrapper {
  overflow-x: auto;
  padding: 8px 12px 4px;
}

.supplier-scroll-wrapper::-webkit-scrollbar {
  height: 6px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.supplier-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
  border-radius: 6px;
}

.supplier-fields-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  min-width: max-content;
  align-items: flex-start;
}

.supplier-field {
  display: flex;
  flex-direction: column;
  min-width: 160px;
  max-width: 160px;
}

.supplier-field--xs {
  min-width: 80px;
  max-width: 80px;
}

.supplier-field--sm {
  min-width: 140px;
  max-width: 140px;
}

.supplier-field--lg {
  min-width: 220px;
  max-width: 220px;
}

.supplier-field--xl {
  min-width: 260px;
  max-width: 260px;
}

.supplier-field .text {
  font-size: 0.78rem;
  color: #707070;
  font-weight: 500;
  white-space: nowrap;
  margin-bottom: 2px;
}
</style>
